import CertsListExport from './CertsListExport';

export default CertsListExport;
